export default "__VITE_ASSET__Dr_bRFE9__"